import React from "react";
import ReactDOM from "react-dom/client";
// import './index.css';
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { ErrorModalProvider } from "./contexts/ErrorModalContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ErrorModalProvider>
          <App />
        </ErrorModalProvider>
      </PersistGate>
    </Provider>
  </BrowserRouter>
);
